import {
  Box,
  Button,
  Card,
  Chip,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowBack, BuildOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import V2PageShell from 'features/v2/V2PageShell';
import { v2Tokens } from 'theme/v2Theme';
import 'styles/v2.css';

const statusRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  py: 1.25,
  borderBottom: '1px solid rgba(255,255,255,0.06)',
};

const InscriptionSandboxPage = () => {
  const navigate = useNavigate();

  return (
    <V2PageShell>
      <Container
        component="main"
        maxWidth={false}
        sx={{ width: '100%', maxWidth: 960, px: { xs: 2, sm: 3 }, py: { xs: 3, md: 6 } }}
      >
          <Card
            component="section"
            aria-labelledby="inscription-sandbox-title"
            sx={{
              position: 'relative',
              overflow: 'hidden',
              p: { xs: 2.5, md: 4 },
              borderRadius: v2Tokens.radius.panel,
              border: '1px solid rgba(255,255,255,0.08)',
              backgroundColor: v2Tokens.surface,
              boxShadow: '0 25px 50px -12px rgba(0,0,0,0.32)',
              '&::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                pointerEvents: 'none',
                background:
                  'linear-gradient(rgba(62,166,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(62,166,255,0.025) 1px, transparent 1px)',
                backgroundSize: '28px 28px',
                maskImage: 'linear-gradient(to bottom right, black, transparent 72%)',
              },
            }}
          >
            <Box
              sx={{
                position: 'relative',
                display: 'grid',
                gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: '7fr 5fr' },
                alignItems: 'stretch',
                gap: { xs: 3, md: 4 },
              }}
            >
              <Stack alignItems="flex-start" spacing={2}>
                <Typography variant="overline" color="primary.main">
                  Arcade Module // Pending
                </Typography>

                <Box
                  sx={{
                    display: 'grid',
                    placeItems: 'center',
                    width: 48,
                    height: 48,
                    color: '#3EA6FF',
                    border: '1px solid rgba(62,166,255,0.28)',
                    borderRadius: v2Tokens.radius.nested,
                    backgroundColor: 'rgba(62,166,255,0.08)',
                    boxShadow: '0 0 10px rgba(62,166,255,0.12)',
                  }}
                >
                  <BuildOutlined aria-hidden="true" />
                </Box>

                <Box>
                  <Typography
                    id="inscription-sandbox-title"
                    component="h1"
                    sx={{
                      color: '#fff',
                      fontSize: { xs: 28, sm: 34 },
                      fontWeight: 800,
                      lineHeight: 1.1,
                      letterSpacing: '-0.035em',
                    }}
                  >
                    Inscription Sandbox
                  </Typography>
                  <Typography
                    color="primary.main"
                    sx={{ mt: 1.25, fontSize: 13, fontWeight: 700 }}
                  >
                    Feature Under Construction
                  </Typography>
                  <Typography
                    color="text.secondary"
                    sx={{ mt: 1.25, maxWidth: 520, fontSize: 13, lineHeight: 1.7 }}
                  >
                    The Inscription Sandbox is being prepared for a future Ordinals creation and experimentation experience.
                  </Typography>
                  <Typography color="text.secondary" sx={{ mt: 1, fontSize: 12 }}>
                    This feature is not currently available.
                  </Typography>
                </Box>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                  <Chip label="Coming Soon" color="primary" variant="outlined" />
                  <Button
                    variant="outlined"
                    color="inherit"
                    startIcon={<ArrowBack />}
                    onClick={() => navigate('/')}
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    Back to Dashboard
                  </Button>
                </Stack>
              </Stack>

              <Box
                aria-label="Inscription Sandbox construction status"
                sx={{
                  alignSelf: 'stretch',
                  p: { xs: 2, sm: 2.5 },
                  border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: v2Tokens.radius.nested,
                  backgroundColor: 'rgba(7,9,13,0.82)',
                }}
              >
                <Typography variant="overline" color="secondary.main">
                  Module Status
                </Typography>

                <Box sx={{ mt: 1 }}>
                  <Box sx={statusRowSx}>
                    <Typography className="v2-technical-label" color="text.secondary" sx={{ fontSize: 10 }}>
                      STATUS
                    </Typography>
                    <Typography className="v2-technical-label" color="primary.main" sx={{ fontSize: 10, fontWeight: 800 }}>
                      COMING SOON
                    </Typography>
                  </Box>
                  <Box sx={statusRowSx}>
                    <Typography className="v2-technical-label" color="text.secondary" sx={{ fontSize: 10 }}>
                      OPERATIONS
                    </Typography>
                    <Typography className="v2-technical-label" sx={{ color: '#E5E5E5', fontSize: 10, fontWeight: 800 }}>
                      DISABLED
                    </Typography>
                  </Box>
                </Box>

                <Typography
                  className="v2-technical-label"
                  sx={{ mt: 2.5, color: '#AEB6C2', fontSize: 11, lineHeight: 1.7 }}
                >
                  Coming Soon — no inscription or transaction will be created.
                </Typography>
              </Box>
            </Box>
          </Card>
      </Container>
    </V2PageShell>
  );
};

export default InscriptionSandboxPage;
